import { useQuery } from 'react-query'
import {
  fetchOrgFlags
} from '../API'

export default (orgId, token) => {
  const {isLoading: isLoadingOrgFlags, data: orgFlags} = useQuery(
    ['org-flags'],
    () => fetchOrgFlags(orgId, token),
    {
      refetchOnWindowFocus: false
    }
  )
  return {
    isLoadingOrgFlags,
    orgFlags
  }
}



// WEBPACK FOOTER //
// ./src/components/mycourses/hooks/useFetchOrgFlags.js